import { CURRENCY_LOCALE } from '../constant';

export const fixed = (value, count = 0) => {
    return (Number(value) || 0).toFixed(count)
}

export function numberToWord(number) {
    number = Math.abs(number);
    const NS = [
        {value: 10000000, str: "Crore"},
        {value: 100000, str: "Lakh"},
        {value: 1000, str: "Thousand"},
        {value: 100, str: "Hundred"},
        {value: 90, str: "Ninety"},
        {value: 80, str: "Eighty"},
        {value: 70, str: "Seventy"},
        {value: 60, str: "Sixty"},
        {value: 50, str: "Fifty"},
        {value: 40, str: "Forty"},
        {value: 30, str: "Thirty"},
        {value: 20, str: "Twenty"},
        {value: 19, str: "Nineteen"},
        {value: 18, str: "Eighteen"},
        {value: 17, str: "Seventeen"},
        {value: 16, str: "Sixteen"},
        {value: 15, str: "Fifteen"},
        {value: 14, str: "Fourteen"},
        {value: 13, str: "Thirteen"},
        {value: 12, str: "Twelve"},
        {value: 11, str: "Eleven"},
        {value: 10, str: "Ten"},
        {value: 9, str: "Nine"},
        {value: 8, str: "Eight"},
        {value: 7, str: "Seven"},
        {value: 6, str: "Six"},
        {value: 5, str: "Five"},
        {value: 4, str: "Four"},
        {value: 3, str: "Three"},
        {value: 2, str: "Two"},
        {value: 1, str: "One"}
    ];

    let result = '';
    for (let n of NS) {
        if (number >= n.value) {
            if (number <= 99) {
                result += n.str;
                number -= n.value;
                if (number > 0) result += ' ';
            } else {
                let t = Math.floor(number / n.value);
                let d = number % n.value;
                if (d > 0) {
                    return numberToWord(t) + ' ' + n.str + ' ' + numberToWord(d);
                } else {
                    return numberToWord(t) + ' ' + n.str;
                }
            }
        }
    }
    return result;
}

export const numberWithComaToFixed = (n, code = 'INR', removeZero = false, locale = "en-IN") => {
    const num = Number(n);
    if (isNaN(num)) return '';

    // Check if the number has decimals
    const hasDecimals = num % 1 !== 0;

    if (code) {
        return num?.toLocaleString(CURRENCY_LOCALE[code]?.secondaryLanguage || locale,
            {
                style: 'currency',
                currency: code,
                minimumFractionDigits: (removeZero && !hasDecimals) ? 0 : 2,
                maximumFractionDigits: (removeZero && !hasDecimals) ? 0 : 2
            });
    } else {
        return num?.toLocaleString(locale)
    }
}

export const numFormatter = (num) => {
    return parseInt(num) > 99 ? '99+' : num;
};

export const isFloat = (n) => Number(n) === n && n % 1 !== 0;

export const getFixed = (n = 0) => isFloat(n) ? Number(n)?.toFixed(2) : Number(n)

export const generateDuration = (duration, startFrom = 1) => {
    let ar = [];
    for (let i = startFrom; i <= duration; i++) {
        ar.push({label: i, value: i});
    }
    return ar;
}

// ===== migrated from pms/src/common/functions/common.jsx =====
export const fixedHours = (hours) => {
    if (Number.isInteger(hours)) {
        return hours.toString();
    } else {
        return hours.toFixed(2);
    }
}
